import axios from "axios";
import router from "../router";
import {
	Message,
	MessageBox
} from 'element-ui';
/** @webpackPreprocess */
import {
	baseUrl,
	timeout
} from '@/common/config'
// 创建 axios 实例
let urlRes = ''
urlRes = window.location.protocol + "//" + window.location.host + "/api/"
if (urlRes.indexOf('localhost') !== -1) {
	urlRes = 'http://122.51.76.10:8801/api/'
	// urlRes = 'http://122.51.76.10:8090/api/'
	
}
if (baseUrl) {
	urlRes = baseUrl
}
const request = axios.create({
	// 请求地址前缀
	baseURL: urlRes,
	timeout: timeout, // 请求超时时间
});
// 异常拦截处理器
const errorHandler = (error) => {
	// console.log(error,333333)
	if (error.response) {
		// 错误、登陆失效等
	} else {
		if (error.request.responseType && error.request.responseType == "blob") {
			// 其他响应数据类型处理
			let reader = new FileReader();
			reader.onload = (e) => {
				let errData = JSON.parse(e.target.result);
			};
			reader.readAsText(error.response.data);
		}
	}
	return Promise.resolve(error);
};
// 请求拦截器
request.interceptors.request.use((config) => {
	// 判断是否有缓存有token
	// 设置请求头
	config.headers = {
		"Content-Type": "application/json",
		"Authorization": ""
	}
	if (!config.auth) {
		let token = localStorage.getItem('access_token')
		config.headers.Authorization = "Bearer " + token
	} else {
		config.headers.Authorization = ""
	}
	return config;
}, errorHandler);
// 响应拦截器
request.interceptors.response.use((response) => {
	// console.log(response,1111)
	if (response.data.code === 0) {
		// 判断是否更新token
		return Promise.resolve(response.data);
	} else if (response.data.code === 401) {
		localStorage.setItem("userinfo", "")
		localStorage.setItem("access_token", "")
		localStorage.setItem("refresh_token", "")
		router.push('/login')
		MessageBox('登录已失效请重新登录', '登陆失效', {
			confirmButtonText: '确定',
		})
		return Promise.reject(response.data);
	} else if (response.data.code === 403) {
		router.push('/not-permission')
	} else {
		Message.error(response.data.msg);
		return Promise.reject(response.data);
	}
	return response.data;
}, errorHandler);

export default request;